module finadai.app.login {
  export var NAME = 'finadai.app.login';
  function LoginController($scope, $state: ng.ui.IStateService, $rootScope: ng.IRootScopeService, authService: finadai.services.AuthService, $location: ng.ILocationService, 
  $localStorage: IFinadaiStorage, tokenAccess, tokenConfirm, $q: ng.IQService, customersService: services.CustomersService, $mdDialog: ng.material.IDialogService){
    $scope.message = null;
    $scope.tokenMessage = null;
   if(tokenAccess != null) {
        if(tokenAccess.status == 200){
            cancelNegotiation(tokenAccess.data.Token);
        }
        else{
            $scope.tokenMessage = { type: 'danger', text: tokenAccess.data.error }
        }
    }
    if(tokenConfirm != null){
      if(tokenConfirm.status == 200){
        loginRedirect(tokenConfirm.data.Token);
      }
      else{
        $scope.tokenMessage = { type: 'danger', text: tokenConfirm.data.error }
      }
    }
    $scope.loginData = { email: '', password: ''};
    var original = angular.copy($scope.loginData);
    $scope.canSubmit = function() {
      return true;
      // return $scope.material_login_form.$valid && !angular.equals($scope.user, original);
    }; 

    $scope.showTerms = (ev) => {
      $mdDialog.show({
        templateUrl: 'app/layout/terms.tpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: false // Only for -xs, -sm breakpoints.
      });
    }

    $scope.login = function() {
      $scope.processingRequest = true;
      $rootScope.$broadcast('preloader:active');
			authService.login($scope.loginData).then(response => {
        if(angular.isDefined(response.data.error)){
          $state.go('changePassword', {
            token: response.data.token,
            email: $scope.loginData.email
          });
        }
        else{
          loginRedirect(response.data.token)
        }
			}, responseLoginError => {
        if(responseLoginError.status == 401){
          $scope.message = { type: 'danger', text: responseLoginError.data.error };
        }
			  $scope.processingRequest = false;
      });
    };

    function loginRedirect(token){
      var queryParams = $location.search();
      $localStorage.apiToken = "Bearer " + token;
      if(angular.isDefined(queryParams.send_to) && angular.isDefined(queryParams.gi) && angular.isDefined(queryParams.cn)){
        $state.go('app.negotiations.create', {granterId: queryParams.gi, customerId: queryParams.cn})
      }
      else{
        authService.isLoggedIn().then(response => {
          if(response.privilege == "customer") {
              $state.go('app.customers.profile');
          } else if (response.privilege == "operational") {
              $state.go('app.admin.search');
          } else {
              $state.go('app.admin.create');
          }
          $scope.processingRequest = false;
        })
      }
    }
    function cancelNegotiation(token) {
        $localStorage.apiToken = "Bearer " + token;
        authService.isLoggedIn().then(response => {
            $state.go('app.customers.cancel_negotiation');
            $scope.processingRequest = false;
        })
    }
  }
  export function run(){
    var login = angular.module(NAME, []);
    login.controller("LoginController", LoginController);
  }
}
finadai.app.login.run();